import {POST_ADD_ACTION} from "../../../../redux/blogsDucks"
import { useDispatch, useSelector } from "react-redux";

const DuplicateModalPost = (props) => {
    const dispatch = useDispatch()
    return (
    <>
        <div className="modal fade " id={"post-duplicate-" + props.post.id} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Duplicar novedad</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    ¿Desea duplicar la novedad <b>"{props.post.title}"</b>? 
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    <button disabled type="button" className="btn btn-danger" data-bs-dismiss="modal">Duplicar</button>
                </div>
                </div>
            </div>
        </div>
    </>)
}

export default DuplicateModalPost